import SliderPartner from './SliderPartner'

export default SliderPartner
